// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangePassword_root__2VFd0","label":"ChangePassword_label__3W0r2","field":"ChangePassword_field__swRNM"};